module.exports = __webpack_public_path__ + "assets/812d4903754aa6baac931234f9b71447.mp3";